<div class="view-switcher">
  <ion-segment (ionChange)="onViewChange($event)" [value]="config.selectedType">
    <ion-segment-button *ngFor="let viewType of config.viewTypes" [value]="viewType.key">
      <img [class]="viewType.icon.class"
           [src]="'assets/icons/' + (viewType.key === config.selectedType ? viewType.icon.activeIconName : viewType.icon.inactiveIconName)">
    </ion-segment-button>
  </ion-segment>
</div>
